export const encode = (input: string) =>
  btoa(
    new TextEncoder()
      .encode(input)
      .reduce((s, b) => s + String.fromCharCode(b), "")
  );

export const decode = (input: string) =>
  decodeURIComponent(escape(atob(input)));
